import FileViewerComponent from 'react-file-viewer';

const FileView = (props) => {
  return <FileViewerComponent {...props} />;
};

export default FileView;
